import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65c023f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-cal-title" }
const _hoisted_2 = { class: "prev-next" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Prev")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_6 = { class: "app-cal" }
const _hoisted_7 = { class: "app-cal-hdr" }
const _hoisted_8 = { class: "app-cal-dates" }
const _hoisted_9 = { class: "app-cal-row-dates" }
const _hoisted_10 = { class: "app-cal-month" }
const _hoisted_11 = { class: "app-cal-date" }
const _hoisted_12 = { class: "date-info" }
const _hoisted_13 = {
  key: 0,
  class: "task-count"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "history-count"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "date-refs"
}
const _hoisted_18 = { class: "list-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "ref-list tasks"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Mentions of ")
const _hoisted_21 = { class: "item-highlight" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_23 = {
  key: 0,
  class: "item-info"
}
const _hoisted_24 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_25 = {
  key: 0,
  class: "ref-list history"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Actions on ")
const _hoisted_27 = { class: "item-highlight" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_29 = {
  key: 0,
  class: "item-info"
}
const _hoisted_30 = {
  key: 1,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_StringLinkList = _resolveComponent("StringLinkList")!
  const _component_StringLinkInfo = _resolveComponent("StringLinkInfo")!
  const _component_o_tab_item = _resolveComponent("o-tab-item")!
  const _component_AppTime = _resolveComponent("AppTime")!
  const _component_o_tabs = _resolveComponent("o-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.months[_ctx.startDate.getMonth()]) + " " + _toDisplayString(_ctx.startDate.getFullYear()), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: _ctx.prevMonth }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _hoisted_4,
      _createVNode(_component_router_link, { to: _ctx.nextMonth }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, idx) => {
          return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(day), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (row, rowIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "app-cal-row",
            key: rowIdx
          }, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (dt, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass([{ 'app-cal-faded': dt.faded, 'day-highlight': _ctx.isUrlDate(dt.mapKey) }, "app-cal-dt-wrapper"])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(dt.m), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(dt.d), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.getTaskCount(dt.mapKey))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.showAll(dt, rowIdx, 'mentions')), ["prevent"])
                          }, _toDisplayString(_ctx.getTaskCount(dt.mapKey)) + " mentions ", 9, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getHistoryCount(dt.mapKey))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.showAll(dt, rowIdx, 'actions')), ["prevent"])
                          }, _toDisplayString(_ctx.getHistoryCount(dt.mapKey)) + " actions ", 9, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]),
            (_ctx.currentRowIdx === rowIdx)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_o_tabs, {
                      modelValue: _ctx.activeTab,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                      expanded: false,
                      size: "large",
                      position: "centered",
                      animated: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_tab_item, {
                          value: "mentions",
                          label: "Mentions"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.getTaskCount(_ctx.currentDay.mapKey))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_20,
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentDay.description), 1),
                                    _hoisted_22
                                  ]),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateItems.get(_ctx.currentDay.mapKey)?.tasks, (item, hIdx) => {
                                      return (_openBlock(), _createElementBlock("li", { key: hIdx }, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_AppBadge, {
                                            priority: item.priority
                                          }, null, 8, ["priority"]),
                                          _createVNode(_component_StringLinkList, {
                                            list: _ctx.processLine(`@${item.refid} - ${item.title}`),
                                            highlight: [_ctx.linkFromDbDt(_ctx.currentDay.mapKey), `${item.dbid}`],
                                            onLinkClick: ($event: any) => (_ctx.showInfo($event, hIdx, 'tasks'))
                                          }, null, 8, ["list", "highlight", "onLinkClick"])
                                        ]),
                                        (_ctx.currentInfo && _ctx.currentIdx === hIdx && _ctx.currentList === 'tasks')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                              _createVNode(_component_StringLinkInfo, {
                                                str: _ctx.currentInfo,
                                                highlight: [_ctx.linkFromDbDt(_ctx.currentDay.mapKey)],
                                                onItemClick: ($event: any) => (_ctx.showInfo($event, hIdx, 'tasks'))
                                              }, null, 8, ["str", "highlight", "onItemClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_24, " No mentions of " + _toDisplayString(_ctx.currentDay.description), 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_o_tab_item, {
                          value: "actions",
                          label: "Actions"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.getHistoryCount(_ctx.currentDay.mapKey))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_26,
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.currentDay.description), 1)
                                  ]),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateItems.get(_ctx.currentDay.mapKey)?.history, (item, hIdx) => {
                                      return (_openBlock(), _createElementBlock("li", { key: hIdx }, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_AppBadge, {
                                            priority: item.priority
                                          }, null, 8, ["priority"]),
                                          _createVNode(_component_AppTime, {
                                            dt: item.timestamp,
                                            highlight: false
                                          }, null, 8, ["dt"]),
                                          _hoisted_28,
                                          _createVNode(_component_StringLinkList, {
                                            list: _ctx.processLine(item.summary),
                                            highlight: [_ctx.linkFromDbDt(_ctx.currentDay.mapKey)],
                                            onLinkClick: ($event: any) => (_ctx.showInfo($event, hIdx, 'history'))
                                          }, null, 8, ["list", "highlight", "onLinkClick"])
                                        ]),
                                        (_ctx.currentInfo && _ctx.currentIdx === hIdx && _ctx.currentList === 'history')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _createVNode(_component_StringLinkInfo, {
                                                str: _ctx.currentInfo,
                                                highlight: [_ctx.linkFromDbDt(_ctx.currentDay.mapKey)],
                                                onItemClick: ($event: any) => (_ctx.showInfo($event, hIdx, 'history'))
                                              }, null, 8, ["str", "highlight", "onItemClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, " Nothing happened on " + _toDisplayString(_ctx.currentDay.description), 1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}